// extracted by mini-css-extract-plugin
module.exports = {"container":"qpU3N2yw","wrapper":"tDE1Jrp_","img":"Av52yWlx","title":"cCRtlSkh","description":"Ngm9CMmY"};